export function NsfwImageOverlay() {
	return (
		<div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-[18px]">
			<div className="flex items-center justify-center rounded-lg bg-gray-800 bg-opacity-90 px-3 py-2 shadow-sm transition-all duration-300">
				<span className="text-xs font-medium text-gray-200">
					Mature Content
				</span>
			</div>
		</div>
	)
}
